import React from 'react';
import Layout from '../../../components/Layout';

export default function OpportunitaPage() {
  return (
    <Layout>
      <div className="page-header">
        <div className="page-header-text">
          <h2>Opportunità</h2>
          <p>CRM - Gestione opportunità commerciali</p>
        </div>
      </div>
      <div className="bop-card">
        <div className="bop-empty-state">
          <svg width="64" height="64" viewBox="0 0 24 24" fill="none"
            stroke="#cbd5e1" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"
            className="bop-empty-state__icon">
            <circle cx="12" cy="12" r="10" />
            <line x1="12" y1="8" x2="12" y2="12" />
            <line x1="12" y1="16" x2="12.01" y2="16" />
          </svg>
          <h3 className="bop-empty-state__title">Funzionalità in sviluppo</h3>
          <p className="bop-empty-state__text">
            La gestione delle opportunità commerciali sarà disponibile in un prossimo aggiornamento.
          </p>
        </div>
      </div>
    </Layout>
  );
}
